export default "__VITE_ASSET__HijwVaeZ__"